import { render, staticRenderFns } from "./SectionReward.vue?vue&type=template&id=dbcb80d0&"
import script from "./SectionReward.vue?vue&type=script&lang=js&"
export * from "./SectionReward.vue?vue&type=script&lang=js&"
import style0 from "./SectionReward.vue?vue&type=style&index=0&id=dbcb80d0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports